


































import { defineComponent, reactive, SetupContext, toRefs, onMounted, onBeforeUnmount } from "@vue/composition-api";
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";

export interface StreamingUrl {
  id: number
  grade_id: number
  url: string
  streaming_date: string
}

export interface Data {
  grade_id: string
  streaming_url: StreamingUrl
  today: string
  is_show: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "drop-area": DropArea,
  },
  setup(props, context: SetupContext) {

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      grade_id: null,
      streaming_url: null,
      today: Common.formatDate(new Date(), "Y年M月D日"),
      is_show: false,
      errors: [],
    });

    /************************************************************
     * 登録URLからブラウザ埋め込み用のURLに変換
     ************************************************************/
    const getEmbedUrlFromYoutubeUrl = (url: string) => {
      // Regular YouTube video
      const videoPattern = /^(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtu\.be\/|youtube\.com\/(?:watch\/?(?:\?v=)?|v\/|embed\/|user\/.+\/u\/\d+\/))([^#&?]*).*/;
      // YouTube live with channel ID
      const liveChannelPattern = /(?:https?:\/\/)?(?:www\.)?youtube\.com\/channel\/([A-Za-z0-9_-]{24})\/live/;
      // YouTube live with video ID
      const liveVideoPattern = /(?:https?:\/\/)?(?:www\.)?youtube\.com\/live\/([A-Za-z0-9_-]{11})\?feature=share/;

      let match = url.match(videoPattern);
      if (match && match[1].length === 11) {
        return `https://www.youtube.com/embed/${match[1]}?autoplay=1&rel=0&modestbranding=1`;
      }

      match = url.match(liveChannelPattern);
      if (match && match[1].length === 24) {
        return `https://www.youtube.com/embed/live_stream?channel=${match[1]}&autoplay=1&rel=0&modestbranding=1`;
      }

      match = url.match(liveVideoPattern);
      if (match && match[1].length === 11) {
        return `https://www.youtube.com/embed/${match[1]}?autoplay=1&rel=0&modestbranding=1`;
      }

      return null;
    }


    /************************************************************
     * 動画エリアの高さを画面サイズに合わせてリサイズ
     * 初期表示・ウィンドウリサイズ時に発動
     ************************************************************/

    const adjustHeight = () => {
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const mainArea = document.getElementById("main-area");
      
      if(mainArea != null){
        mainArea.style.width = windowWidth + "px";
        mainArea.style.height = (windowHeight - mainArea.offsetTop) + "px";
      }
    };

    /************************************************************
     * 視聴終了ボタン押下
     ************************************************************/
    const updateEndTime = async () => {
      
      if(context.root.$store.state.currentUser.role != "student"){
        window.history.back();
        return;
      }

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/streaming_view/update_end_time/`, {student_num: context.root.$store.state.student_num, grade_id: state.grade_id, streaming_date: state.streaming_url.streaming_date}).then(response => {
        window.history.back();
      })
      .catch(error=>{
        alert("視聴終了の記録に失敗しました。\n再度視聴ページにアクセスし、視聴終了ボタンを押してください。");
        window.history.back();
      });

      context.root.$store.dispatch("hideOverlay");
    }

    const beginStreaming = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      const student_num = context.root.$store.state.currentUser.role == "student" ? context.root.$store.state.student_num : "";

      await http.get(`/api/streaming_view?grade_id=${state.grade_id}&student_num=${student_num}`).then(response => {
        state.streaming_url = response.data.streaming_url;
        state.streaming_url.url = getEmbedUrlFromYoutubeUrl(state.streaming_url.url);
        if(!state.streaming_url.url){
          alert(`処理に失敗しました。\n動画URLが不正です。`);
          window.history.back();
        }else{
          state.is_show = true;
          context.root.$nextTick(() => {
            adjustHeight();
          });
        }
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`処理に失敗しました。\n${error.response.data.errors[0]}`);
        }else{
          alert(`処理に失敗しました。`);
        }
        window.history.back();
      });
      
      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      state.grade_id = context.root.$route.params.grade_id;      
      context.root.$store.commit("setIsHeaderDisp", false);
      window.addEventListener("resize", adjustHeight);
    });

    /************************************************************
     * before unmount windowイベント解除・排他制御解除
     ************************************************************/
    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      updateEndTime,
      adjustHeight,
      beginStreaming,
    };
  },
})
